var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("fieldset", [
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-radios", {
          attrs: {
            name: "app-background-check",
            label: _vm.t("app-background-check"),
            options: _vm.backgroundCheckRootOptions,
            required: "true",
          },
          on: { input: _vm.onBackgroundCheckChanged },
          model: {
            value: _vm.program.attributes.field_ns_bg_check,
            callback: function ($$v) {
              _vm.$set(_vm.program.attributes, "field_ns_bg_check", $$v)
            },
            expression: "program.attributes.field_ns_bg_check",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.program.attributes.field_ns_bg_check === "app-yes"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "ui-form-row" },
            [
              _c("checkboxes", {
                attrs: {
                  label: _vm.t("app-program-background-check-type"),
                  options: _vm.backgroundCheckType,
                  cols: 4,
                  required: true,
                },
                on: { input: _vm.onBackgroundCheckTypeChanged },
                model: {
                  value: _vm.program.attributes.field_ns_bg_check_types,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.program.attributes,
                      "field_ns_bg_check_types",
                      $$v
                    )
                  },
                  expression: "program.attributes.field_ns_bg_check_types",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isChecked(0)
            ? _c(
                "div",
                { staticClass: "ui-form-row" },
                [
                  _c("app-radios", {
                    attrs: {
                      name: "app-background-check-fingerprint-type",
                      label: _vm.t("app-background-check-fingerprint-type"),
                      options: _vm.backgroundCheckFingerprintType,
                      required: "true",
                    },
                    model: {
                      value:
                        _vm.program.attributes.field_ns_bg_fingerprint_type,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.program.attributes,
                          "field_ns_bg_fingerprint_type",
                          $$v
                        )
                      },
                      expression:
                        "program.attributes.field_ns_bg_fingerprint_type",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isChecked(1)
            ? _c(
                "div",
                { staticClass: "ui-form-row" },
                [
                  _c("app-radios", {
                    attrs: {
                      name: "app-background-check-name-type",
                      label: _vm.t("app-background-check-name-type"),
                      options: _vm.backgroundCheckNameType,
                      required: "true",
                    },
                    model: {
                      value: _vm.program.attributes.field_ns_bg_name_type,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.program.attributes,
                          "field_ns_bg_name_type",
                          $$v
                        )
                      },
                      expression: "program.attributes.field_ns_bg_name_type",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isChecked(2)
            ? _c(
                "div",
                { staticClass: "ui-form-row" },
                [
                  _c("checkboxes", {
                    attrs: {
                      label: _vm.t("app-background-check-other-type"),
                      options: _vm.backgroundCheckOtherType,
                      cols: 2,
                      required: true,
                    },
                    model: {
                      value: _vm.program.attributes.field_ns_bg_other_types,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.program.attributes,
                          "field_ns_bg_other_types",
                          $$v
                        )
                      },
                      expression: "program.attributes.field_ns_bg_other_types",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.program.attributes.field_ns_bg_check ===
    "app-background-check-type-peer"
      ? _c(
          "div",
          { staticClass: "ui-form-row" },
          [
            _c("app-radios", {
              attrs: {
                name: "app-background-check-peer-type",
                label: _vm.t("app-background-check-peer-bg-check"),
                options: _vm.yesOrNo,
                required: "true",
              },
              model: {
                value: _vm.program.attributes.field_ns_bg_peer_type,
                callback: function ($$v) {
                  _vm.$set(_vm.program.attributes, "field_ns_bg_peer_type", $$v)
                },
                expression: "program.attributes.field_ns_bg_peer_type",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }